<div class="section-bandeiras">
  <div class="container">
    <div id="ct-bandeiras" class="container-bandeiras">
      <div class="bandeiras">
        <div *ngFor="let bandeira of bandeiras" class="box-bandeira">
          <img
            [ngStyle]="
              bandeira.maxWidth ? { 'max-width': bandeira.maxWidth } : {}
            "
            [lazyLoad]="bandeira.icon"
            alt=""
          />
        </div>
      </div>
      <div class="text-center mt-4">
        <p id="texto">Consulte todas as bandeiras</p>
        <span (click)="mostraMais()"
          ><img
            id="seta-baixo"
            [lazyLoad]="'assets/img/seta-bottom.png'"
            alt=""
        /></span>
      </div>
    </div>
  </div>
</div>
